/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';
import {ServiceError} from '@ion/core/src/types/services';

const selectModularSearch       = ({adminUsers: {search}}) => search;
const selectUserMove            = ({adminUsers: {move}}) => move;
const selectUserMoveSelected    = state => selectUserMove(state).selected;
const selectUserMoveShowDialog  = state => selectUserMove(state).isEditing;
const selectUserMoveResult      = state => selectUserMove(state).result;
const selectUserMoveShowLoading = state => selectUserMove(state).loading;
const selectUserviewMovedResult = state => selectUserMove(state).viewMovedUsers;
const selectUserviewMovedErrors = state => selectUserMove(state).errors;

export const modularSearchSelector = createDeepEqualSelector(
  selectModularSearch, search => search
);
export const userMoveShowDialogSelector = createSelector(
  selectUserMoveShowDialog, (isEditing: boolean) => isEditing
);
export const userMoveSelectedUsersSelector = createDeepEqualSelector(
  selectUserMoveSelected, selected => selected
);
export const userMoveShowLoadingSelector = createSelector(
  selectUserMoveShowLoading, (loading: boolean) => loading
);
export const userMoveResultSelector = createDeepEqualSelector(
  selectUserMoveResult, result => result
);
export const userMoveErrorsSelector = createDeepEqualSelector(
  selectUserviewMovedErrors, (errors: ServiceError[]): ServiceError[] => errors
);
export const adminUsersViewMovedResultsSelector = createSelector(
  selectUserviewMovedResult, (viewMovedUsers: boolean) => viewMovedUsers
);
